<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary">
          <i class="text-primary fas fa-paste"></i> Exam Type
        </h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />
        </div>
        <div class="col-md-3 text-md-start text-end mt-5">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save text-white"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()">
            <i class="fa fa-times-circle me-1"></i> Cancel
          </button>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-md-3">
          <label>
            <input type="checkbox" value="REFLECTION" v-model="Obj.Participation" />
            REFLECTION
          </label>
        </div>
        <div class="col-md-3">
          <label>
            <input type="checkbox" value="PROJECT WORK" v-model="Obj.Participation" />
            PROJECT WORK
          </label>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-md-3">
          <label>
            <input type="checkbox" value="WRITTEN WORK" v-model="Obj.Participation" />
            WRITTEN WORK
          </label>
        </div>
        <div class="col-md-3">
          <label>
            <input type="checkbox" value="SLIP TEST" v-model="Obj.Participation" />
            SLIP TEST
          </label>
        </div>
      </div>

      <div class="row g-3 mt-1">
        <div class="col-md-3 d-flex align-items-center">
          <label class="mb-0">
            <input type="checkbox" v-model="Obj.sum" />
            Sum
          </label>
        </div>
      </div>

      <div class="row g-3 mt-1" v-if="Obj.sum">
        <div class="col-md-2">
          <label class="form-label">Exam Type</label>
          <select class="form-select form-select-sm" v-model="Obj.selExType1">
            <option value="">Select</option>
            <option v-for="item in row1" :key="item._id || item.Name" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          +
        </div>
        <div class="col-md-2">
          <label class="form-label">Exam Type</label>
          <select class="form-select form-select-sm" v-model="Obj.selExType2">
            <option value="">Select</option>
            <option v-for="item in row1" :key="item._id || item.Name" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row g-3">
        <div class="col-md-3">
          <input type="checkbox" :checked="Obj.tblType === 'COMPREHENSIVE'"
            @change="setTblType('COMPREHENSIVE', $event.target.checked)" />
          COMPREHENSIVE
          <table border="1" class="custom-table fs-6">
            <thead>
              <tr>
                <th>COMPREHENSIVE FEEDBACK</th>
                <th>A</th>
                <th>B</th>
                <th>C</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>READING SKILLS</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>COMMUNICATION SKILLS</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>READING OF LANGUAGES</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>NEATNESS OF UNIFORM</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>CLASSROOM INTERACTION</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row g-3">
        <div class="col-md-6">
          <input type="checkbox" :checked="Obj.tblType === 'CO-CURRICULAR'"
            @change="setTblType('CO-CURRICULAR', $event.target.checked)" />
          CO-CURRICULAR
          <table border="1" class="custom-table fs-6">
            <thead>
              <tr>
                <th>CO-CURRICULAR ACTIVITIES</th>
                <th>MARKS</th>
                <th>CO-CURRICULAR SUBJECTS</th>
                <th>MARKS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Value Education &amp; Life Skills (50M)</td>
                <td></td>
                <td>Computer Education (50M / 100M)</td>
                <td></td>
              </tr>
              <tr>
                <td>Arts &amp; Cultural Education (50M)</td>
                <td></td>
                <td>GK (50M)</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>Vedic math’s (50M / 100M)</td>
                <td></td>
              </tr>
              <tr>
                <td>Health &amp; Physical Education (50M)</td>
                <td></td>
                <td>Communication (50M)</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>Abacus</td>
                <td></td>
              </tr>
              <tr>
                <td>Total Grade</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="row">
        <div class="col-md-6 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress != 0">
            <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
              :style="{ width: progress + '%' }"></div>
          </div>
          <DataTable v-if="progress == 0" :columns="col1" :rows="row1" :pageSize="10"
            :actions="{ edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from "@/utils/helpers.js";
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
const store = useStore();
const getDefaultObj = () => ({
  Name: "",
  Participation: [],
  tblType: "",
  sum: false,
  selExType1: "",
  selExType2: "",
});
const Obj = ref(getDefaultObj());
const msgObj = ref({ msg: "", role: "", show: false });
const delObj = ref({});
const errors = ref({});
const col1 = ref([
  { label: "S.No", key: "Sno" },
  { label: "Name", key: "Name" },
]);
const handleEdit = (row) => {
  Obj.value = {
    ...getDefaultObj(),
    ...row,
    Participation: Array.isArray(row.Participation) ? [...row.Participation] : [],
  };
};
const handleDelete = (row) => {
  delObj.value = { ...row };
};
const setTblType = (type, checked) => {
  if (checked) {
    Obj.value.tblType = type;
    return;
  }

  if (Obj.value.tblType === type) {
    Obj.value.tblType = "";
  }
};
const row1 = ref([]);
const save = async () => {
  const fields = {
    Name: { value: Obj.value.Name, validators: [isRequired] },
  };
  const idx = row1.value.findIndex(
    (item) =>
      item.Name.toLowerCase() === Obj.value.Name.toLowerCase() &&
      item._id !== Obj.value._id,
  );
  if (idx >= 0) {
    msgObj.value = {
      msg: "Exam Type already exists.",
      role: "danger",
      show: true,
    };
    return;
  }
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/ExamType${url}`, Obj.value)
      .then(() => {
        loadData();
        reset();
        msgObj.value = {
          msg: `ExamType ${msg} Successfully`,
          role: "success",
          show: true,
        };
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
const reset = async () => {
  Obj.value = getDefaultObj();
  msgObj.value = { msg: "", role: "", show: false };
  errors.value = {};
};
const progress = ref(0);
const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get("/ExamType/search").then((response) => {
    row1.value = response.data.map((item, i) => ({ ...item, Sno: i + 1 }));
    store.commit("setExamTypes", response.data);
    progress.value = 0;
    clearInterval(progressInterval);
  });
};
const delRecord = async () => {
  await api.delete(`/ExamType/${delObj.value._id}`).then(() => {
    loadData();
    delObj.value = {};
    msgObj.value = {
      msg: "ExamType Deleted Successfuly.",
      role: "danger",
      show: true,
    };
  });
};
onMounted(() => {
  loadData();
});
</script>
